var map = {
	"./decision/company_profile.svg": 627,
	"./decision/envelope_mail.svg": 628,
	"./decision/profile.svg": 629,
	"./organization/organization_companyname.svg": 630,
	"./organization/organization_companywebsite.svg": 631,
	"./organization/organization_corebusiness.svg": 632,
	"./organization/organization_deleteaccount.svg": 633,
	"./organization/organization_description.svg": 634,
	"./organization/organization_fulltimeemployees.svg": 635,
	"./organization/organization_funding.svg": 636,
	"./organization/organization_incorporationdate.svg": 637,
	"./organization/organization_industrySector.svg": 638,
	"./organization/organization_language.svg": 639,
	"./organization/organization_location.svg": 640,
	"./organization/organization_logo.svg": 641,
	"./organization/organization_mainTechnology.svg": 642,
	"./organization/organization_marketstage.svg": 643,
	"./organization/organization_members.svg": 644,
	"./organization/organization_socialmedia.svg": 645,
	"./organization/organization_tags.svg": 646,
	"./other/dff-logo.svg": 647,
	"./other/icon_check-circle.svg": 648,
	"./other/icon_check.svg": 649,
	"./other/icon_cross-circle.svg": 650,
	"./other/icon_cross.svg": 651,
	"./other/icon_eye-closed.svg": 652,
	"./other/icon_eye-open.svg": 653,
	"./other/icon_hamburger.svg": 654,
	"./other/icon_logout.svg": 655,
	"./other/icon_plus-circle.svg": 656,
	"./other/icon_plus.svg": 227,
	"./other/icon_profile.svg": 657,
	"./other/icon_questionmark.svg": 658,
	"./other/icon_redo.svg": 659,
	"./other/icon_settings.svg": 660,
	"./other/icon_tick-circle.svg": 661,
	"./other/icon_uncheck-circle.svg": 662,
	"./other/icon_upload.svg": 663,
	"./other/icon_vertical-menu.svg": 664,
	"./other/intro_explore.svg": 665,
	"./other/intro_fill.svg": 666,
	"./other/intro_services.svg": 667,
	"./other/moon.svg": 668,
	"./other/sun.svg": 669,
	"./personal/personal_biography.svg": 670,
	"./personal/personal_dateofbirth.svg": 671,
	"./personal/personal_education.svg": 672,
	"./personal/personal_email.svg": 673,
	"./personal/personal_female.svg": 674,
	"./personal/personal_firstname.svg": 675,
	"./personal/personal_gender.svg": 676,
	"./personal/personal_lastname.svg": 677,
	"./personal/personal_location.svg": 678,
	"./personal/personal_male.svg": 679,
	"./personal/personal_mobile.svg": 680,
	"./personal/personal_nationality.svg": 681,
	"./personal/personal_newsletter.svg": 682,
	"./personal/personal_password.svg": 683,
	"./personal/personal_photo.svg": 684,
	"./personal/personal_slogan.svg": 685,
	"./personal/personal_socialmedia.svg": 686,
	"./personal/personal_tags.svg": 687,
	"./personal/personal_title.svg": 688,
	"./personal/personal_verification.svg": 689,
	"./platforms/area-app.svg": 690,
	"./platforms/area-web.svg": 691,
	"./platforms/platforms.svg": 692,
	"./platforms/programs.svg": 693,
	"./settings/settings_admin.svg": 316,
	"./settings/settings_computer.svg": 694,
	"./settings/settings_deleteaccount.svg": 695,
	"./settings/settings_identity.svg": 696,
	"./settings/settings_language.svg": 697,
	"./settings/settings_laptop.svg": 698,
	"./settings/settings_mobile.svg": 699,
	"./settings/settings_newsletter.svg": 700,
	"./settings/settings_tablet.svg": 701,
	"./settings/settings_theme.svg": 702,
	"./settings/settings_tutorial.svg": 703,
	"./settings/settings_twofactorauthorisation.svg": 704,
	"./social/social_facebook.svg": 705,
	"./social/social_facebook2.svg": 706,
	"./social/social_instagram.svg": 707,
	"./social/social_instagram2.svg": 708,
	"./social/social_linkedin.svg": 709,
	"./social/social_linkedin2.svg": 710,
	"./social/social_snapchat.svg": 711,
	"./social/social_twitter.svg": 712,
	"./social/social_twitter2.svg": 713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 626;